import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./alarmes.component.html')
})
export class AlarmesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/alarmes.component.ts
 **/